import { IconHomeSearch } from '@tabler/icons-react'
import ButtonPrime from '@/components/navigation/ButtonPrime'
import React from 'react'
import { Link } from 'react-router-dom'

export default function VorteileSection() {
  return (
    <div>
        <div className='max-w-[85rem] px-4 md:py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto'>
        <div className='py-10'>
            {/* <h2 className='font-semibold text-dark-100 font-serif text-2xl'>Ihre Vorteile</h2> */}
        <div className='md:flex flex-wrap justify-between py-5 block'>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/bewertung-vorteile-1.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Unverbindlich starten</h3>
                <p className='text-dark-200 '>Lassen Sie Ihre Immobilie kostenlos und ohne Verpflichtungen bewerten – ganz einfach und transparent.
                </p>
            </div>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12 ' src="/Icons/bewertung-vorteile-2.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Marktwert erfahren</h3>
                <p className='text-dark-200 '>Wir kennen den lokalen Markt – und bewerten Ihre Immobilie fundiert, realistisch und mit Erfahrung.
                </p>
            </div>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/bewertung-vorteile-3.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Klarheit schaffen</h3>
                <p className='text-dark-200 '>Wir hören zu und nehmen uns Zeit für Ihre Fragen – persönlich und mit Erfahrung seit 1978.
                </p>
            </div>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/bewertung-vorteile-4.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Sicher entscheiden</h3>
                <p className='text-dark-200 '>Der Immobilienbewertung schafft Klarheit – als Grundlage für Ihren nächsten Schritt.
                </p>
            </div>

        </div>
        <Link to='/bewerten/formular/online-bewertung'>
        <ButtonPrime text='Jetzt Bewertung starten' icon={<IconHomeSearch/>} className='w-full mx-auto md:w-fit mt-10' />
        </Link>

        </div>

    </div>

    </div>
  )
}
